import React, { useState } from 'react'
import { MDBCol, MDBBtn, MDBIcon } from "mdbreact";

const Formulario = () => {
    const [datos, setDatos] = useState({
        nombre: '',
        correo: '',
        email: '',
        asunto: '',
        mensaje: ''
    })
    const handleSubmit = (e) => {
        e.preventDefault();
    }

    const guardarInformacion = (event) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        setDatos((e) => ({ ...e, [name]: value }))
    }

    return (
        <form onSubmit={handleSubmit}>
            <MDBCol className='mt-2'>
                <label htmlFor="defaultFormContactNameEx" className="grey-text">
                    Nombre
                </label>
                <input
                    name='nombre'
                    type="text"
                    value={datos.nombre}
                    onChange={guardarInformacion}
                    className="form-control"
                    required
                />
            </MDBCol>

            <MDBCol className='mt-2'>
                <label htmlFor="defaultFormContactEmailEx" className="grey-text">
                    Correo
                </label>
                <input
                    name='email'
                    value={datos.email}
                    onChange={guardarInformacion}
                    type="email"
                    className="form-control"
                    required
                />
            </MDBCol>
            <MDBCol className='mt-2'>
                <label htmlFor="defaultFormContactSubjectEx" className="grey-text">
                    Asunto
                </label>
                <input
                    name='asunto'
                    type="text"
                    value={datos.asunto}
                    onChange={guardarInformacion}
                    className="form-control"
                    required
                />
            </MDBCol>
            <MDBCol className='mt-2'>
                <label htmlFor="defaultFormContactMessageEx" className="grey-text">
                    Mensaje
                </label>
                <textarea
                    name='mensaje'
                    value={datos.mensaje}
                    onChange={guardarInformacion}
                    type="text"
                    className="form-control"
                    rows="3"
                    required
                />
            </MDBCol>
            <MDBCol>
                <div className="text-center mt-4">
                    <MDBBtn color="warning" type="submit">
                        Enviar
                        <MDBIcon far icon="paper-plane" className="ml-2" />
                    </MDBBtn>
                </div>
            </MDBCol>
        </form>

    )
}

export default Formulario